import { Button, styled } from '@mui/material';

import Image from '../../../components/image';
import thumbnailConsultation from './consultation-teaser-person.jpg';
import thumbnailServiceTestSrc from './service-test.jpg';

type Thumbnail = {
  consultation: string;
  serviceTest: string;
};
export const thumbnail: Thumbnail = {
  consultation: thumbnailConsultation,
  serviceTest: thumbnailServiceTestSrc,
};

const InlineConsultationTeaser = ({
  onClick,
  buttonLabel,
  description,
  thumbnailKey,
  ...dataProps
}: {
  buttonLabel: string;
  description: string;
  onClick: () => void;
  thumbnailKey: keyof Thumbnail;
  [key: `data-${string}`]: string;
}) => {
  return (
    <Wrapper {...dataProps}>
      <Image
        images={[
          { src: thumbnail[thumbnailKey], width: 100, height: 100, media: '' },
        ]}
        alt={buttonLabel}
      />
      <TextWrapper>
        <p>{description}</p>
        <Button onClick={onClick}>{buttonLabel}</Button>
      </TextWrapper>
    </Wrapper>
  );
};

export default InlineConsultationTeaser;

const Wrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  paddingTop: '20px',
  paddingBottom: '48px',

  img: {
    width: '100px',
    height: '100px',
    overflow: 'hidden',
    borderRadius: '50%',
    marginRight: '26px',
    flexShrink: 0,
  },

  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',

    img: {
      marginRight: 0,
    },
  },

  [theme.breakpoints.down('sm')]: {
    paddingTop: '14px',
    paddingBottom: '8px',

    img: {
      width: '80px',
      height: '80px',
    },
  },
}));

const TextWrapper = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  p: {
    ...theme.typography.body,
    fontWeight: theme.typography.fontWeightMedium,
    margin: 0,
    width: '90%',

    // maxWidth: '280px',

    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
      marginTop: '12px',
      marginBottom: '2px',
    },

    [theme.breakpoints.up('md')]: {
      width: '90%',
    },

    [theme.breakpoints.up(1550)]: {
      width: '70%',
    },

    [theme.breakpoints.up(400)]: {
      width: '60%',
    },
  },
}));
